// This plugin replaces the default drop behavior
// because it doesn't play well with undo and redo
// behaviors.

import { ReactEditor } from 'slate-react';
import { Transforms, Range, Editor } from 'slate';
import type AhaEditor from '../../AhaEditor';
import History from '../../collaboration/History';

const DropPlugin = {
  name: 'Drop plugin',
  handlers: {
    onDrop: (event: DragEvent, ahaEditor: AhaEditor) => {
      const { editor } = ahaEditor;
      // Keep a reference to the dragged range before updating selection
      const draggedRange = editor.selection;

      // Find the range where the drop happened
      const range = ReactEditor.findEventRange(editor, event);
      const data = event.dataTransfer;
      if (!data) return;

      History.getForEditor(editor).addNewUndo(editor, () => {
        Transforms.select(editor, range);

        if (
          draggedRange &&
          !Range.equals(draggedRange, range) &&
          !Editor.void(editor, { at: range, voids: true })
        ) {
          Transforms.delete(editor, {
            at: draggedRange,
          });
        }
      });

      ReactEditor.insertData(editor, data);

      // When dragging from another source into the editor, it's possible
      // that the current editor does not have focus.
      if (!ReactEditor.isFocused(editor)) {
        ReactEditor.focus(editor);
      }

      return true;
    },
  },
};

export default DropPlugin;
